import { render } from "./UserAddView.vue?vue&type=template&id=53833bfc&scoped=true"
import script from "./UserAddView.vue?vue&type=script&lang=js"
export * from "./UserAddView.vue?vue&type=script&lang=js"

import "./UserAddView.vue?vue&type=style&index=0&id=53833bfc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53833bfc"]])

export default __exports__